function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 1C4.693 1 2 3.67 2 6.95c0 1.472.545 2.823 1.44 3.86l.002.004.002.002s2.553 2.889 3.461 3.749c.609.575 1.58.575 2.189 0 1.036-.98 3.463-3.75 3.463-3.75v-.002l.003-.002A5.9 5.9 0 0014 6.95C14 3.67 11.307 1 8 1zm0 1.05c2.735 0 4.941 2.188 4.941 4.9a4.846 4.846 0 01-1.186 3.179c-.005.005-2.488 2.821-3.392 3.676a.52.52 0 01-.727 0c-.755-.715-3.384-3.668-3.392-3.676v-.001A4.84 4.84 0 013.059 6.95c0-2.712 2.206-4.9 4.941-4.9zm0 2.8c-.662 0-1.225.265-1.587.669a2.13 2.13 0 00-.53 1.431c0 .51.168 1.028.53 1.431.362.404.925.669 1.587.669.662 0 1.225-.265 1.587-.669.362-.403.53-.92.53-1.431 0-.51-.168-1.028-.53-1.431C9.225 5.115 8.662 4.85 8 4.85zM8 5.9c.397 0 .628.129.795.316.168.187.264.457.264.734 0 .277-.096.547-.264.734C8.628 7.871 8.397 8 8 8s-.628-.129-.795-.316a1.11 1.11 0 01-.264-.734c0-.277.096-.547.264-.734.167-.187.398-.316.795-.316z",
  fill: "#595351",
  fillRule: "evenodd"
});

function SvgAddressinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgAddressinline;